export default __webpack_public_path__ + "static/media/t3.f905994d.svg";